export const BUILD_VERSION = '1786021442';
